import {EventDispatcher} from './EventDispatcher.js';
import {log, warn} from './logfunctions.js';
import {
  COMPLETE
} from './constants.js';

/**
 * Font load-status watcher for confirming that fonts have finished loading.
 *
 * Requires FontFaceObserver. See:
 * https://github.com/bramstein/fontfaceobserver
 *
 * FontFaceObserver can be included as a standalone asset as follows:
 * <script type="text/javascript" src="lib/fontfaceobserver.standalone.js"></script>
 */
export class FontWatcher extends EventDispatcher {

  /**
   * Waits until the specified font families have all either loaded or failed to load, then
   * dispatches a COMPLETE event. If all specified font families have already loaded, or no font
   * families are specified, immediately dispatches COMPLETE.
   *
   * @param families A Set of string font-family names, such as "Arial" or "Times New Roman".
   */
  watchFonts (families) {
    if (families.size > 0) {
      let numFontLoadAttemptsResolved = 0;
      families.forEach(family => {
        let fontFaceObserver = new FontFaceObserver(family);
        fontFaceObserver.load(null, 30000).then(font => {
          // Font load success
          log('Loaded font: ' + family);
          numFontLoadAttemptsResolved++;
          this.checkIfAllFontsHaveLoaded(numFontLoadAttemptsResolved, families.size);
        }, font => {
          // Font load error
          numFontLoadAttemptsResolved++;
          warn('Failed to load: ' + family);
          this.checkIfAllFontsHaveLoaded(numFontLoadAttemptsResolved, families.size);
        });
      });
    } else {
      this.done();
    }
  }

  checkIfAllFontsHaveLoaded (numFontLoadAttemptsResolved, numFonts) {
    if (numFontLoadAttemptsResolved === numFonts) {
      this.done();
    }
  }

  done () {
    this.dispatchEvent(COMPLETE);
  }
}
